export default __webpack_public_path__ + "static/media/alli-mini-aentli.9f226112.webp";